/**
 * Public URL mounts for wasm-pack pkgs (browser-safe — no Node/Bun APIs).
 *
 * Bun HMR exposes `import.meta.url` as `file://`, which browsers refuse to
 * import, so glue + `.wasm` are fetched from these HTTP paths instead.
 */
export const CURVA_TESS_WASM_PUBLIC_PREFIX = "/wasm/curva-tess/";
export const CURVA_SCRIPT_WASM_PUBLIC_PREFIX = "/wasm/curva-script/";

/** True in the browser (including the Bun HMR client). */
export function shouldLoadWasmPkgOverHttp(): boolean {
  return typeof Bun === "undefined";
}
